import ApiService from '@/common/api.service';
import { SET_PRODUCTS, SET_CURRENT_PRODUCT, SET_CURRENT_CATEGORY } from '../mutations.type';
import {
  FETCH_PRODUCTS,
  FETCH_PRODUCT,
  FETCH_PRODUCT_CONTENT,
  DOWNLOAD_PRODUCT,
} from '../actions.type';

const state = {
  products: [],
  filters: [],
  total: 0,
  pages: 0,
  currentProduct: null,
  currentCategory: null,
};

const getters = {
  products() {
    return state;
  },
  currentProduct() {
    return state.currentProduct;
  },
  currentCategory() {
    return state.currentCategory;
  },
};
const actions = {
  [FETCH_PRODUCTS](context, payload) {
    // eslint-disable-next-line no-param-reassign
    payload.locale = localStorage.getItem('lang');
    context.commit(SET_CURRENT_CATEGORY, payload.type);
    return new Promise((resolve, reject) => {
      ApiService.query('public/vtstack/products', payload)
        .then(({ data }) => {
          context.commit(SET_PRODUCTS, data);
          resolve(data);
        }).catch((data) => {
          reject(data);
        });
    });
  },
  [FETCH_PRODUCT](context, productSlug) {
    context.commit(SET_CURRENT_PRODUCT, productSlug);
    return getters.currentProduct() !== null;
  },
  [FETCH_PRODUCT_CONTENT](context, productId) {
    // eslint-disable-next-line no-param-reassign
    return new Promise((resolve) => {
      ApiService.downloadQuery(`public/vtstack/preview/${productId}`)
        .then((data) => {
          const type = data.headers['content-type'];
          const blob = new Blob([data.data], { type });
          const url = URL.createObjectURL(blob);
          resolve(url);
        });
    });
  },
  [DOWNLOAD_PRODUCT](context, payload) {
    return new Promise((resolve) => {
      ApiService.downloadQuery(`vtstack/product/${payload.id}?lang=${payload.lang}`)
        .then((data) => {
          const type = data.headers['content-type'];
          const blob = new Blob([data.data], { type });
          const url = URL.createObjectURL(blob);
          const fileLink = document.createElement('a');
          fileLink.href = url;
          fileLink.setAttribute('download', payload.fileName);
          document.body.appendChild(fileLink);
          fileLink.click();
          resolve();
        });
    });
  },
};
const mutations = {
  [SET_PRODUCTS](_, { data }) {
    const {
      packs, filters, total, pages,
    } = data;
    state.products = packs;
    state.filters = filters ?? [];
    state.total = total;
    state.pages = pages;
  },
  [SET_CURRENT_PRODUCT](states, productSlug) {
    const { products } = states;
    states.currentProduct = null;

    products.every((product) => {
      if (product.Slug === productSlug) {
        states.currentProduct = product;
        return false;
      }
      return true;
    });
  },
  [SET_CURRENT_CATEGORY](states, category) {
    states.currentCategory = category;
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
